import React from 'react';
import Spinner from '~/components/ui/Spinner';
import cn from 'classnames';

interface LoadingIndicatorProps {
  message?: string;
  blockScreen?: boolean;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  message,
  blockScreen = false,
}) => {
  return (
    <div
      className={`
        flex
        flex-col
        justify-center
        items-center
        top-0
        right-0
        bottom-0
        left-0
        z-50
        ${blockScreen ? 'fixed' : 'absolute'}
        ${blockScreen && 'bg-blackForReal bg-opacity-60'}
      `}
    >
      <Spinner />
      <span className={cn('mt-2', blockScreen && 'text-white')}>{message}</span>
    </div>
  );
};

export { LoadingIndicator };
